import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useMe } from './Session';
import { AccountSheet } from './AccountSheet';
import { NAV_ITEMS } from './Nav';
import { IconMore } from './icons';
import './shell.css';

/**
 * The phone tab bar. Four primary sections plus More, in the iOS pattern —
 * a scrolling tab bar reads as a web page, and this must not.
 */
export function TabBar() {
  const { can } = useMe();
  const [moreOpen, setMoreOpen] = useState(false);
  const primary = NAV_ITEMS.filter((i) => i.primary && can(i.module));

  return (
    <>
      <nav className="sh-tabs no-print" aria-label="Sections">
        {primary.map(({ to, short, icon: Icon }) => (
          <NavLink key={to} to={to} end={to === '/'} className="sh-tab">
            <Icon className="sh-tab__icon" size={20} />
            {short}
          </NavLink>
        ))}
        <button
          type="button"
          className="sh-tab"
          aria-expanded={moreOpen}
          onClick={() => setMoreOpen(true)}
        >
          <IconMore className="sh-tab__icon" size={20} />
          More
        </button>
      </nav>
      <AccountSheet open={moreOpen} onClose={() => setMoreOpen(false)} />
    </>
  );
}
